import { autostoreDesignSystemPrimitives } from "./primitives";

const { primary, secondary, tertiary } = autostoreDesignSystemPrimitives;

export const autostoreDesignSystemColors = {
  background: {
    /** Figma: background/default */
    default: primary.asWhite,
    /** Figma: background/alternate */
    alternate: primary.asWarmGray100,
    /** Figma: background/inverse */
    inverse: primary.asBlack800
  },
  brand: {
    /** Figma: brand/red */
    red: primary.asBrandRed,
    /** Figma: brand/warm-gray */
    warmGray: primary.asWarmGray300,
    /** Figma: brand/white */
    white: primary.asWhite,
    /** Figma: brand/black */
    black: primary.asBlack900
  },
  border: {
    onStandard: {
      /** Figma: border/on-standard/input-default */
      inputDefault: primary.asWarmGray500,
      /** Figma: border/on-standard/input-hover */
      inputHover: primary.asWarmGray600,
      /** Figma: border/on-standard/input-disabled */
      inputDisabled: primary.asWarmGray200,
      /** Figma: border/on-standard/surface-default */
      surfaceDefault: primary.asWarmGray300,
      /** Figma: border/on-standard/surface-black */
      surfaceBlack: primary.asBlack900,
      /** Figma: border/on-standard/status-informative */
      statusInformative: secondary.asBlue700,
      /** Figma: border/on-standard/status-positive */
      statusPositive: tertiary.asGreen700,
      /** Figma: border/on-standard/status-warning */
      statusWarning: tertiary.asYellow700,
      /** Figma: border/on-standard/status-negative */
      statusNegative: primary.asRed700
    },
    onInverse: {
      /** Figma: border/on-inverse/input-default */
      inputDefault: primary.asWarmGray700,
      /** Figma: border/on-inverse/input-hover */
      inputHover: primary.asWarmGray600,
      /** Figma: border/on-inverse/input-disabled */
      inputDisabled: primary.asBlack800,
      /** Figma: border/on-inverse/surface-default */
      surfaceDefault: primary.asBlack800,
      /** Figma: border/on-inverse/surface-white */
      surfaceWhite: primary.asWhite
    }
  },
  surface: {
    static: {
      /** Figma: surface/static-default */
      default: primary.asWhite,
      /** Figma: surface/static-alternate */
      alternate: primary.asWarmGray100,
      /** Figma: surface/static-inverse */
      inverse: primary.asBlack900,
      /** Figma: surface/static-informative */
      informative: secondary.asBlue100,
      /** Figma: surface/static-positive */
      positive: tertiary.asGreen100,
      /** Figma: surface/static-warning */
      warning: tertiary.asYellow100,
      /** Figma: surface/static-negative */
      negative: primary.asRed100
    },
    interactive: {
      base: {
        /** Figma: surface/interactive-base-default */
        default: primary.asWhite,
        /** Figma: surface/interactive-base-hover */
        hover: primary.asWarmGray50,
        /** Figma: surface/interactive-base-active */
        active: primary.asWarmGray200,
        /** Figma: surface/interactive-base-disabled */
        disabled: primary.asWhite,
        /** Figma: surface/interactive-base-selected */
        selected: secondary.asBlue100
      },
      baseAlt: {
        /** Figma: surface/interactive-base-alt-default */
        default: primary.asWarmGray50,
        /** Figma: surface/interactive-base-alt-hover */
        hover: primary.asWarmGray100,
        /** Figma: surface/interactive-base-alt-active */
        active: primary.asWarmGray200,
        /** Figma: surface/interactive-base-alt-disabled */
        disabled: primary.asWarmGray50
      },
      accent: {
        /** Figma: surface/interactive-accent-default */
        default: secondary.asBlue700,
        /** Figma: surface/interactive-accent-hover */
        hover: secondary.asBlue800,
        /** Figma: surface/interactive-accent-active */
        active: secondary.asBlue900,
        /** Figma: surface/interactive-accent-disabled */
        disabled: secondary.asBlue300
      },
      muted: {
        /** Figma: surface/interactive-muted-default */
        default: primary.asWarmGray300,
        /** Figma: surface/interactive-muted-hover */
        hover: primary.asWarmGray400,
        /** Figma: surface/interactive-muted-active */
        active: primary.asWarmGray500,
        /** Figma: surface/interactive-muted-disabled */
        disabled: primary.asWarmGray200
      },
      negative: {
        /** Figma: surface/interactive-negative-default */
        default: primary.asRed700,
        /** Figma: surface/interactive-negative-hover */
        hover: primary.asRed800,
        /** Figma: surface/interactive-negative-active */
        active: primary.asRed900,
        /** Figma: surface/interactive-negative-disabled */
        disabled: primary.asRed300
      }
    }
  },
  text: {
    onStandard: {
      /** Figma: text/on-standard/primary */
      primary: primary.asBlack800,
      /** Figma: text/on-standard/secondary */
      secondary: primary.asWarmGray700,
      /** Figma: text/on-standard/disabled */
      disabled: primary.asWarmGray400,
      /** Figma: text/on-standard/link-default */
      linkDefault: secondary.asBlue800,
      /** Figma: text/on-standard/link-hover */
      linkHover: secondary.asBlue700,
      /** Figma: text/on-standard/status-informative */
      statusInformative: secondary.asBlue800,
      /** Figma: text/on-standard/status-positive */
      statusPositive: tertiary.asGreen800,
      /** Figma: text/on-standard/status-warning */
      statusWarning: tertiary.asYellow800,
      /** Figma: text/on-standard/status-negative */
      statusNegative: primary.asRed700
    },
    onInverse: {
      /** Figma: text/on-inverse/primary */
      primary: primary.asWarmGray100,
      /** Figma: text/on-inverse/secondary */
      secondary: primary.asWarmGray300,
      /** Figma: text/on-inverse/disabled */
      disabled: primary.asWarmGray500,
      /** Figma: text/on-inverse/link-default */
      linkDefault: secondary.asBlue400,
      /** Figma: text/on-inverse/link-hover */
      linkHover: secondary.asBlue300
    }
  },
  icon: {
    onStandard: {
      /** Figma: icon/on-standard/primary */
      primary: primary.asBlack800,
      /** Figma: icon/on-standard/secondary */
      secondary: primary.asWarmGray600,
      /** Figma: icon/on-standard/disabled */
      disabled: primary.asWarmGray400,
      /** Figma: icon/on-standard/status-informative */
      statusInformative: secondary.asBlue700,
      /** Figma: icon/on-standard/status-positive */
      statusPositive: tertiary.asGreen700,
      /** Figma: icon/on-standard/status-warning */
      statusWarning: tertiary.asYellow700,
      /** Figma: icon/on-standard/status-negative */
      statusNegative: primary.asRed700
    },
    onInverse: {
      /** Figma: icon/on-inverse/primary */
      primary: primary.asWarmGray100,
      /** Figma: icon/on-inverse/secondary */
      secondary: primary.asWarmGray300,
      /** Figma: icon/on-inverse/disabled */
      disabled: primary.asWarmGray500
    }
  },
  label: {
    /** Figma: label/blue-1 */
    blue1: secondary.asBlue300,
    /** Figma: label/blue-2 */
    blue2: secondary.asBlue200,
    /** Figma: label/purple-1 */
    purple1: tertiary.asPurple400,
    /** Figma: label/purple-2 */
    purple2: tertiary.asPurple300,
    /** Figma: label/purple-3 */
    purple3: tertiary.asPurple200,
    /** Figma: label/red-1 */
    red1: primary.asRed300,
    /** Figma: label/red-2 */
    red2: primary.asRed200,
    /** Figma: label/yellow-1 */
    yellow1: tertiary.asYellow300,
    /** Figma: label/yellow-2 */
    yellow2: tertiary.asYellow200,
    /** Figma: label/green-1 */
    green1: tertiary.asGreen200,
    /** Figma: label/green-2 */
    green2: tertiary.asGreen400,
    /** Figma: label/green-3 */
    green3: tertiary.asGreen600
  },
  charts: {
    primary: {
      /** Figma: charts/primary-1 */
      1: secondary.asBlue800,
      /** Figma: charts/primary-2 */
      2: secondary.asBlue700,
      /** Figma: charts/primary-3 */
      3: secondary.asBlue500,
      /** Figma: charts/primary-4 */
      4: secondary.asBlue400,
      /** Figma: charts/primary-5 */
      5: secondary.asBlue300,
      /** Figma: charts/primary-6 */
      6: secondary.asBlue200
    },
    accent: {
      /** Figma: charts/accent-1 */
      1: tertiary.asYellow800,
      /** Figma: charts/accent-2 */
      2: tertiary.asYellow600,
      /** Figma: charts/accent-3 */
      3: tertiary.asYellow400,
      /** Figma: charts/accent-4 */
      4: tertiary.asGreen800,
      /** Figma: charts/accent-5 */
      5: tertiary.asGreen600,
      /** Figma: charts/accent-6 */
      6: tertiary.asGreen400,
      /** Figma: charts/accent-7 */
      7: tertiary.asPurple800,
      /** Figma: charts/accent-8 */
      8: tertiary.asPurple600,
      /** Figma: charts/accent-9 */
      9: tertiary.asPurple400
    },
    negative: {
      /** Figma: charts/negative-1 */
      1: primary.asRed700,
      /** Figma: charts/negative-2 */
      2: primary.asRed600,
      /** Figma: charts/negative-3 */
      3: primary.asRed300
    }
  },
  /** Multi-temperature storage zone colors. */
  mts: {
    /** Figma: mts/ambient */
    ambient: tertiary.asYellow600,
    /** Figma: mts/cooled */
    cooled: tertiary.asYellow300,
    /** Figma: mts/chilled */
    chilled: secondary.asBlue200,
    /** Figma: mts/frozen */
    frozen: secondary.asBlue500,
    /** Figma: mts/organic */
    organic: tertiary.asPurple700
  },
  parts: {
    /** Figma: parts/stock-area-text */
    stockAreaText: primary.asBlack800,
    /** Figma: parts/stock-area-background */
    stockAreaBackground: primary.asWarmGray200,
    /** Figma: parts/ports-text */
    portsText: primary.asWarmGray100,
    /** Figma: parts/ports-background */
    portsBackground: tertiary.asGreen800,
    /** Figma: parts/ports-furniture-background */
    portsFurnitureBackground: tertiary.asGreen200,
    /** Figma: parts/port-frame-text */
    portFrameText: primary.asWarmGray100,
    /** Figma: parts/port-frame-background */
    portFrameBackground: tertiary.asPurple800,
    /** Figma: parts/charger-text */
    chargerText: tertiary.asYellow900,
    /** Figma: parts/charger-background */
    chargerBackground: tertiary.asYellow600,
    /** Figma: parts/service-wall-text */
    serviceWallText: primary.asRed900,
    /** Figma: parts/service-wall-background */
    serviceWallBackground: primary.asRed200,
    /** Figma: parts/service-area-text */
    serviceAreaText: tertiary.asYellow900,
    /** Figma: parts/service-area-background */
    serviceAreaBackground: tertiary.asYellow300,
    /** Figma: parts/street-cell-text */
    streetCellText: secondary.asBlue900,
    /** Figma: parts/street-cell-background */
    streetCellBackground: secondary.asBlue300,
    /** Figma: parts/buffer-cell-text */
    bufferCellText: tertiary.asGreen900,
    /** Figma: parts/buffer-cell-background */
    bufferCellBackground: tertiary.asGreen300,
    /** Figma: parts/exit-cell-text */
    exitCellText: primary.asRed900,
    /** Figma: parts/exit-cell-background */
    exitCellBackground: primary.asRed300,
    /** Figma: parts/blocked-cell-text */
    blockedCellText: primary.asRed900,
    /** Figma: parts/blocked-cell-background */
    blockedCellBackground: primary.asRed400,
    /** Figma: parts/zero-cell-text */
    zeroCellText: tertiary.asPurple900,
    /** Figma: parts/zero-cell-background */
    zeroCellBackground: tertiary.asPurple200,
    /** Figma: parts/access-point */
    accessPoint: primary.asWarmGray200,
    /** Figma: parts/frozen-cell-text */
    frozenCellText: secondary.asBlue900,
    /** Figma: parts/frozen-cell-background */
    frozenCellBackground: secondary.asBlue500,
    /** Figma: parts/frozen-chamber-background */
    frozenChamberBackground: secondary.asBlue600
  },
  colour: autostoreDesignSystemPrimitives
} as const;

export type AutostoreDesignSystemColors = typeof autostoreDesignSystemColors;
